export default {"src":"/_next/static/media/Tools.67026e58.svg","height":16,"width":16};